import { ConfigurationState } from '../models/configuration.model';

const initialConfigurationState: ConfigurationState = {
    uploadStatus: {},
    selectedFiles: [],
    uploadingFiles: [],
    isUploadModalVisible: false,
    fieldErrors: [],
    deleteData: {},
    trendingData: {},
    keyIndicators: {},
    staticIndicators: {},
    frequentlyUsed: {},
    hierarchicalData: {},
    whatsNew: {},
    selectedIndicatorsForAdd: [],
    geographyOverview: {},
    fileUploadLogData: {},
    reorderData: {},
    saveIndicator: {},
    saveTrendingData: {},
    saveWhatsNewIndicator: {},
    saveWhatsNewLink: {},
    indicatorSources: {},
    addIndicatorSource: {},
    updateIndicatorSource: {},
    deleteIndicatorSource: {},
    saveVideoLink: {},
    updateVideoLink:{},
    videoLink: {}
};

export default initialConfigurationState;
